import { render } from "./ThSortable.vue?vue&type=template&id=71dc6238&scoped=true"
import script from "./ThSortable.vue?vue&type=script&lang=js"
export * from "./ThSortable.vue?vue&type=script&lang=js"

import "./ThSortable.vue?vue&type=style&index=0&id=71dc6238&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adewale\\OneDrive - kochind.com\\Documents\\zoloscan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dc6238"]])

export default __exports__